export const SettingsActionTypes = {
    APPLICATION: 'APPLICATION'
};
